import React from 'react';

import { useIntl } from 'react-intl';

import DecisionIcon from '@atlaskit/icon/core/decision';
import { token } from '@atlaskit/tokens';

import { AdditionalNoteBase } from './AdditionalNoteBase';
import { messages } from './messages';

export const HighlightDecisionField = ({
	highlight,
}: {
	highlight?: { summary: string; description: string };
}): React.JSX.Element => {
	const intl = useIntl();
	return (
		<AdditionalNoteBase
			icon={<DecisionIcon size="medium" label="" color={token('color.icon.accent.green')} />}
			title={highlight?.summary || intl.formatMessage(messages.newDecision)}
			description={highlight?.description}
			testId="project-status-update-action-renderer.ui.highlight-decision"
		/>
	);
};
